export const IconsClassNameMap = {
  expanded: 'grid-expanded-icon',
  collapsed: 'grid-expand-icon',
  lastChild: '',
};
